<template>
  <div v-bind:class="{
          'balance': true,
          'balance--presentation': isPresentation,
        }" v-if="isBalanceLoaded">
    <PopupBackdrop v-if="popup.activePopupId === 'top-up'">
      <div class="popup">
        <TopUpBlock v-bind:onCloseClick="closePopup" v-bind:toggleButtonRef="$refs.amountButtonRef" />
      </div>
    </PopupBackdrop>
    <PopupBackdrop v-if="popup.activePopupId === 'currency'">
      <div class="popup">
        <CurrencySelect v-bind:onCloseClick="closePopup" v-bind:toggleButtonRef="$refs.currencyButtonRef" />
      </div>
    </PopupBackdrop>

    <div class="balance-button balance-amount" v-if="!isPresentation" @click="showTopUpPopup" ref="amountButtonRef">
      <span>{{ numberWithSpaces(amount) }}</span>
    </div>
    <div class="balance-button balance-currency" @click="showCurrencyPopup" ref="currencyButtonRef">
      <span class="balance-currency-sign" v-if="!isPresentation">{{getCurrencySign(currency)}}
      </span>
      <span>{{currency}}</span>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import getCurrencySign from "../helpers/getCurrencySing";
import TopUpBlock from "./header/TopUpBlock";
import CurrencySelect from "./CurrencySelect";
import PopupBackdrop from './header/PopupBackdrop';

export default {
  name: "Balance",
  components: {
    TopUpBlock,
    CurrencySelect,
    PopupBackdrop
  },
  props: {
    onClick: Function,
  },
  computed: {
    ...mapState("auth", ["currency"]),
    ...mapState("app", ["popup", "isPresentation"]),
    ...mapGetters("balance", ["isBalanceLoaded", "balances"]),
    amount() {
      const { currency } = this.$store.state.auth;
      return this.$store.state.balance.balances[currency] || '0';
    }
  },
  mounted() {
    this.$store.dispatch("balance/getBalance").then(() => {
      const balanceByDefault = 1000000000000;

      if(this.isPresentation) {
        Object.keys(this.balances).forEach(currency => {
          const currencyBalance = this.balances[currency];
          if(currencyBalance < 1000000000000) {
            this.$store.dispatch("balance/addMoney", { amount: (balanceByDefault - currencyBalance).toFixed(), currency  })
          }
        })
      }
    });
  },
  methods: {
    getCurrencySign,
    numberWithSpaces(x) {
      if (!x) {
        return x;
      }
      const parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return parts.join(".");
    },
    showCurrencyPopup() {
      this.togglePopup("currency");
    },
    showTopUpPopup() {
      this.togglePopup("top-up");
    },
    togglePopup(id) {
      this.$store.dispatch("app/togglePopup", id);
    },
    closePopup() {
      this.$store.dispatch("app/togglePopup", null);
    },
  },
};
</script>

<style scoped>
.balance {
  display: flex;
}

.balance--presentation .balance-currency {
  border-radius: 16px;
}
.balance--presentation .balance-button {
  padding: 0 4px;
}

.balance-button {
  display: flex;
  align-content: center;
  flex-wrap: wrap;
  height: 32px;
  padding: 0 10px;
  border-radius: 16px;
  background: #2A3F4C;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}
.balance-amount {
  border-radius: 16px 4px 4px 16px;
}
.balance-currency {
  margin-left: 4px;
  border-radius: 4px 16px 16px 4px;
}
.balance-currency-sign {
  opacity: 0.5;
}
.balance-currency-sign::after {
  content: " ";
  white-space: pre;
}

.popup {
  position: absolute;
  top: 16px;
  right: 16px;
}
</style>
